// @flow

import React from 'react';

import { DETAILS_FACILITY } from '@routes';
import { Link, useTranslation } from '@i18n';

import {
  StyledPageCover,
  StyledCoverMaxWidthNoBottomMargin
} from '@components/Wrappers/styles/index';
import theme from '@lib/theme';
import {
  LocationIcon,
  StyledBedsCount,
  StyledBioHeading,
  StyledBioText,
  StyledBioTextWrapper,
  StyledBookButton,
  StyledButtonsWrapper,
  StyledButtonsWrapperMobile,
  StyledDoctorImage,
  StyledDoctorName,
  StyledDoctorVariantCard,
  StyledDoctorVariantListWrapper,
  StyledImageCover,
  StyledKnowMore,
  StyledLocation,
  StyledVariantInner,
  StyledVariantInnerLeft,
  StyledVariantInnerRight
} from '../styles';
import type { HospitalVariantListProps } from './types';

const HospitalVariantList = ({ Hospitals, isMobile }: HospitalVariantListProps) => {
  const { t } = useTranslation(['Variants']);

  return (
    <StyledDoctorVariantListWrapper>
      {Hospitals.map((hospital, idx) => (
        <StyledPageCover
          bgcolor={idx % 2 === 0 ? 'white' : theme.colors.whitishBlue}
          key={hospital.id}
        >
          <StyledCoverMaxWidthNoBottomMargin key={hospital.id}>
            <StyledDoctorVariantCard>
              <StyledVariantInner>
                <StyledVariantInnerLeft size={{ mobile: 1 / 3 }} hide={isMobile}>
                  <StyledImageCover hospital>
                    <StyledDoctorImage
                      facility
                      src={hospital.attributes.photo_url}
                      alt="Hospital-Cover-Image"
                    />
                  </StyledImageCover>
                </StyledVariantInnerLeft>
                <StyledVariantInnerRight size={{ mobile: 1, desktop: 2 / 3 }}>
                  <StyledDoctorName>{hospital.attributes.name}</StyledDoctorName>
                  <StyledLocation>
                    <LocationIcon src="/svg/costPage/location-mark.svg" alt="Location-Icon" />
                    {hospital.attributes.city}
                    <StyledBedsCount>
                      {t('Beds', { count: hospital.attributes.number_of_beds || '' })}
                    </StyledBedsCount>
                  </StyledLocation>
                  <StyledVariantInnerLeft size={{ mobile: 1 }} hide={!isMobile}>
                    <StyledImageCover hospital>
                      <StyledDoctorImage
                        facility
                        src={hospital.attributes.photo_url}
                        alt="Hospital-Cover-Image"
                      />
                    </StyledImageCover>
                  </StyledVariantInnerLeft>
                  <StyledBioHeading>{t('Highlights')}</StyledBioHeading>
                  <StyledBioTextWrapper>
                    <StyledBioText
                      dangerouslySetInnerHTML={{ __html: hospital.attributes.description }}
                    />
                    <Link
                      href={DETAILS_FACILITY}
                      params={{ slug: hospital.attributes.slug }}
                      passHref
                    >
                      <StyledKnowMore>{t('KnowMore')}</StyledKnowMore>
                    </Link>
                  </StyledBioTextWrapper>

                  <StyledButtonsWrapper>
                    <Link
                      href={DETAILS_FACILITY}
                      params={{ slug: hospital.attributes.slug }}
                      passHref
                    >
                      <StyledBookButton>{t('BookButton')}</StyledBookButton>
                    </Link>

                  </StyledButtonsWrapper>
                  <StyledButtonsWrapperMobile>
                    <Link
                      href={DETAILS_FACILITY}
                      params={{ slug: hospital.attributes.slug }}
                      passHref
                    >
                      <StyledBookButton>{t('BookButton')}</StyledBookButton>
                    </Link>
                  </StyledButtonsWrapperMobile>
                </StyledVariantInnerRight>
              </StyledVariantInner>
            </StyledDoctorVariantCard>
          </StyledCoverMaxWidthNoBottomMargin>
        </StyledPageCover>
      ))}
    </StyledDoctorVariantListWrapper>
  );
};

export default HospitalVariantList;
